import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserFragmentDoc } from '../../../../../../../graphql/fragments/generated/User';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LearnerProfileGroupsWidgetQueryVariables = Types.Exact<{
  learnerId: Types.Scalars['String']['input'];
}>;


export type LearnerProfileGroupsWidgetQuery = { user?: { id: string, userGroups: Array<{ id: string, name: string, type: Types.GroupTypeEnum, usersCount: number, isAutoSync: boolean, sampleUsers: Array<{ id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null }> }> } | null };

export type LearnerProfileGroupsWidgetItemFragment = { id: string, name: string, type: Types.GroupTypeEnum, usersCount: number, isAutoSync: boolean, sampleUsers: Array<{ id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null }> };


export type LearnerProfileGroupsWidgetItemFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const LearnerProfileGroupsWidgetItemFragmentDoc = /*#__PURE__*/ gql`
    fragment LearnerProfileGroupsWidgetItem on UserCollectionGroupType {
  id
  name
  type
  usersCount
  sampleUsers {
    ...User
  }
  isAutoSync(userId: $learnerId)
}
    `;
export const LearnerProfileGroupsWidgetDocument = /*#__PURE__*/ gql`
    query learnerProfileGroupsWidget($learnerId: String!) {
  user(filters: {userId: $learnerId}) {
    id
    userGroups {
      ...LearnerProfileGroupsWidgetItem
    }
  }
}
    ${LearnerProfileGroupsWidgetItemFragmentDoc}
${UserFragmentDoc}`;

export function useLearnerProfileGroupsWidgetQuery(options: Omit<Urql.UseQueryArgs<LearnerProfileGroupsWidgetQueryVariables>, 'query'>) {
  return Urql.useQuery<LearnerProfileGroupsWidgetQuery, LearnerProfileGroupsWidgetQueryVariables>({ query: LearnerProfileGroupsWidgetDocument, ...options });
};